import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageRequest, SpringPage } from '@shared/page';
import { addPaginationAndHttpParams } from '@shared/utils/request-utils';
import { TrackingEvent } from '../models/tracking';
import { OgoResponseItems } from './ogo-response';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  constructor(private readonly http: HttpClient) {}

  public getTrackings(query: any, pageRequest: PageRequest): Observable<SpringPage<TrackingEvent>> {
    return this.http.get<SpringPage<TrackingEvent>>('admin/tracking', {
      params: addPaginationAndHttpParams(query, pageRequest),
    });
  }
}
